import createCrudService from '@/services/_crudService';

export default createCrudService('/master/report_target_asset');
